<template>
  <div>
    <page-heading
      :heading="
        procedure.name + ' (' + (baseInfo.procedureUserOwner && baseInfo.procedureUserOwner.user ? baseInfo.procedureUserOwner.user.full_name : '') +  ')'
    ">
      <span slot="help"></span>
      <div slot="right"></div>
    </page-heading>


    <el-card>
      <div style="display: flex; justify-content: space-between">
        <div class="smz-card-name">Сводка по годовому бонусу</div>
        <div v-if="baseInfo.procedureUserOwner" style="">
          <el-button
            v-if="$canAndRulesPass(baseInfo.procedureUserOwner, 'year_bonus_user.agree')"
            type="success"
            size="mini"
            :loading="loadingAgreed"
            :disabled="baseInfo.procedureUserOwner.status === 2"
            @click="markAgreed"
          >
            <span v-if="baseInfo.procedureUserOwner.status !== 2">Подтвердите ознакомление</span>

          </el-button>
          <el-button
            v-if="baseInfo.procedureUserOwner.status === 2"
            disabled
            type="info"
            size="mini"
          >
            Ознакомлен
          </el-button>

        </div>
      </div>

      <table
        class="smz-base-table"
        v-loading="loadingHeader"
      >
        <thead>
        <tr>
          <th>Вид вознаграждения</th>
          <th>Количество сотрудников</th>
<!--          <th>Годовой бонус, итого руб.</th>-->
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>Годовой бонус</td>
          <td>{{ baseInfo.procedure_users.length }}</td>
<!--          <td>{{ baseInfo.procedureTotalYearBonus | numberFormat  }}</td>-->
        </tr>
        </tbody>
      </table>

    </el-card>

    <el-card style="margin-top: 30px" id="procedure-details-card">
      <div class="smz-card-name">Детали</div>

      <el-row :gutter="20">
        <el-col :span="4" v-loading="loadingHeader">
          <div
            v-if="baseInfo.procedureUserOwner.user_id === user.id"
            style="margin-bottom: 20px"
          >
            <el-button
              :disabled="!$canAndRulesPass(baseInfo.procedureUserOwner, 'year_bonus_user.see_my_bonus')"
              style="width: 100%; padding: 8px 5px"
              :type="selectedEmployeeId===user.id ? 'primary' : ''"
              @click="loadMyInfo"
            >
              Мой годовой бонус
              <el-popover
                placement="top"
                width="400"
                trigger="click"
              >
                <el-button
                  slot="reference"
                  class="table-action-button open-desc-button"
                  type="text"
                  round
                  size="mini"
                  icon="fas fa-info-circle"
                ></el-button>
                <div>Доступно для просмотра после того, как Ваш Руководитель подтвердит ознакомление</div>
              </el-popover>
            </el-button>

          </div>

          <div style="margin-bottom: 10px;text-transform: uppercase; font-weight: bold; color: #145969; font-size: 14px;line-height: 1;">Годовой бонус подчиненных</div>
          <div>
            <el-radio-group
              v-model="selectedEmployeeId"
              style="width: 100%"
              @change="loadEmployeeInfo"
            >
              <div v-for="procedure_user in baseInfo.procedure_users">
                <el-radio-button class="year-bonus-user-radio" :label="procedure_user.user_id">
                  <div v-if="!procedure_user.history_user">Нет данных на дату процедуры</div>
                  <div v-else>{{procedure_user.history_user.last_name}} {{procedure_user.history_user.first_name}} {{procedure_user.history_user.middle_name}}</div>
                </el-radio-button>
              </div>
            </el-radio-group>
          </div>
        </el-col>

        <el-col :span="20" v-loading="loadingEmployeeInfo">
          <card-stages-block
            v-show="false"
          ></card-stages-block>
          <card-sections
            ref="card_sections"
            :no-permission="true"
          ></card-sections>
          <div v-if="!employeeInfo.procedure_user" style="text-align: center; color:red !important;">Выберите подчиненного</div>
          <div v-else-if="!employeeInfo.procedure_user.history_user" style="text-align: center;">Нет данных на дату процедуры</div>
          <div v-else>

            <table class="smz-base-table">
              <tbody>
              <tr>
                <td>База для расчета годового бонуса, руб.</td>
                <td>{{employeeInfo.procedure_user.total_year_salary | numberFormat}}</td>
              </tr>
              <tr>
                <td>Целевой % годового бонуса на 31.12.{{procedure.year}}</td>
                <td>{{employeeInfo.procedure_user.history_user.year_bonus_percent}} %</td>
              </tr>
              <tr>
                <td>Годовой бонус при 100% КПЭ, руб.</td>
                <td>{{employeeInfo.procedure_user.year_bonus_value_by_month_sum | numberFormat}}</td>
              </tr>
              <tr>
                <td>Размер годового бонуса за {{procedure.year}} год с учетом % КПЭ {{procedure.year}}</td>
                <td>{{employeeInfo.procedure_user.total_year_bonus | numberFormat}}</td>
              </tr>
              <tr>
                <td>Взвешенный коэф-т выполнения КПЭ</td>
                <td>{{weightTotalSum}} %</td>
              </tr>
              </tbody>
            </table>

            <el-button
              style="float: right; margin-top: 20px"
              type="text"
              size="mini"
              icon="fas fa-file-excel"
              :loading="loadingDownloader"
              @click="exportToExcel"
            >
              Экспорт в XLSX
            </el-button>
          </div>
        </el-col>
      </el-row>


    </el-card>

  </div>

</template>

<script>

import requestSender from "@/api/base/requestSender";
import ClickToEdit from "@/components/ClickToEdit.vue";
import PageHeading from "@/components/PageHeading.vue";
import {mapGetters} from "vuex";
import CardSections from "@/components/cards/CardElementsBlock/CardSections.vue";
import CardStagesBlock from "@/components/cards/CardStagesBlock/CardStagesBlock.vue";
import { downloader } from "@/mixins/downloader";

export default {
  name: "YearBonusTemplate",
  components: { CardStagesBlock, CardSections, PageHeading, ClickToEdit},
  mixins:[downloader],
  props: {
    procedure: {type: Object, required: true},
  },

  computed: {
    ...mapGetters(['user']),
    ...mapGetters('card', {
      card: 'card'
    }),
    ...mapGetters('card/sections', {
      sections: 'sections',
      sectionsElements: 'sectionsElements'
    }),
    weightTotalSum() {
      let totalWeight = 0;

      this.sections.forEach(section => {
        // Пропускаем эти секции
        if( ['career', 'growth'].includes(section.type) ){
          return
        }

        if( !this.sectionsElements[section.id] ){
          return;
        }
        this.sectionsElements[section.id].forEach(e => {
          totalWeight += +e.scale.weight_fact;
        })
      })

      return +totalWeight.toFixed(2);
    },
  },

  data() {

    return {
      loadingHeader: false,
      loadingEmployeeInfo: false,
      loadingAgreed: false,

      evaluations: [],

      baseInfo:{
        procedure_users: [],
        procedureTotalYearBonus: null,
        procedureUserOwner: [],
      },

      selectedEmployeeId: null,
      employeeInfo: {},

    }
  },

  mounted() {
    this.getEvaluations();
    this.getHeaderInfo();
  },
  methods: {

    getEvaluations() {
      requestSender('get', 'evaluation/search')
        .then(({evaluations}) => {
          this.evaluations = evaluations;
        })
    },

    getHeaderInfo() {
      this.loadingHeader = true;

      requestSender('get', 'compensation-procedure-year-bonus/get-base-info', {
        procedure_id: this.procedure.id,
        user_id: parseInt(this.$route.params.owner_id),
        expand: 'user, permissions',
      })
        .then(data => {
          this.baseInfo.procedureTotalYearBonus = data.procedure_total_year_bonus;
          this.baseInfo.procedureUserOwner = data.procedure_user_owner;
          this.baseInfo.procedure_users = data.procedure_users;
        })
        .finally(() => {
          this.loadingHeader = false;
        });
    },

    loadMyInfo(){
      this.selectedEmployeeId = this.user.id;
      this.loadEmployeeInfo();
    },

    loadEmployeeInfo() {
      this.loadingEmployeeInfo = true;
      document.getElementById('procedure-details-card').scrollIntoView({ behavior: "smooth"});

      const procedureUser = this.baseInfo.procedure_users.find(u => u.user_id === this.selectedEmployeeId);
      this.$store.dispatch('card/loadCard', {id: procedureUser.card_id});

      requestSender('get', 'compensation-procedure-year-bonus/get-employee-info', {
        procedure_id: this.procedure.id,
        employee_id: this.selectedEmployeeId,
      })
        .then(data => {
          this.employeeInfo = data.employee_info;
        })
        .finally(() => {
          this.loadingEmployeeInfo = false;
        });
    },




    markAgreed(){
      this.loadingAgreed = true;

      requestSender('get', 'compensation-procedure-year-bonus/mark-agreed', {
        procedure_id: this.procedure.id,
        user_id: parseInt(this.$route.params.owner_id),
      })
        .finally(() => {
          this.getHeaderInfo();
          this.loadingAgreed = false;
        });
    },

    exportToExcel() {
      this.downloadFile(
        'export.xlsx',
        this.$api.exportImport.export,
        {
          entity: ('cardKpi'),
          data: {
            id: this.card.id,
            withSummary: true,
            skipCompetences: true,
            employeeInfo: this.employeeInfo
          }}
      )
    },


  },


}
</script>

<style lang="scss">
.year-bonus-user-radio{
  border-left: 1px solid #DCDFE6;
  width: 100%;

  & .el-radio-button__inner {
    width: 100%;
    white-space: normal;
  }
}

.summary-table{
  margin-top: 15px;
  width: 100%;
  text-align: end;
  border-bottom: 1px solid #DCDFE6;
  color: #a1a1a1;

  &-name {
    text-align: start;
    font-weight: bold;
  }
}

</style>